var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountMenuAccountInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_166_24364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.347 9.34385C23.9628 2.07516 16.1817 -1.75134 8.96375 0.781246C2.95657 2.88198 -0.760365 8.96887 0.131667 15.2804C0.614681 18.7283 2.13203 21.531 4.64671 23.674C4.98173 23.9669 5.33139 24.2436 5.69446 24.5024C6.11933 24.8054 6.56291 25.0837 7.02234 25.3368C8.94789 26.3963 11.1601 27 13.5138 27C15.8674 27 18.0532 26.404 19.9702 25.3563C20.1239 25.2722 20.2755 25.1853 20.4256 25.0955C23.9356 22.996 26.4092 19.3458 26.8995 15.0923C27.1329 13.1955 26.9666 11.235 26.3474 9.34385H26.347ZM3.11635 11.9512C3.79208 6.80233 8.27867 2.96648 13.5162 2.9287C14.2858 3.04123 15.0742 3.08795 15.8345 3.2663C20.9594 4.42006 24.4226 9.12813 23.9347 14.3611C23.6737 17.2207 22.4406 19.5221 20.4252 21.3381V20.4727C20.2987 18.0494 18.4081 16.0942 16.0114 15.876H10.0924C7.7123 16.0958 5.83148 18.0259 5.6847 20.4232C3.60221 18.0714 2.6805 15.2532 3.11595 11.9508L3.11635 11.9512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0518 15.1468C15.3787 15.1468 17.2632 13.2605 17.2632 10.9388C17.2632 8.61707 15.3819 6.73083 13.0551 6.73083C10.7282 6.73083 8.84375 8.61707 8.84375 10.9388C8.84375 13.2605 10.725 15.1468 13.0518 15.1468Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_166_24364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountMenuAccountInfo);
export default __webpack_public_path__ + "static/media/account-menu-account-info.6d84450817b53ec55a06e03c6ca26681.svg";
export { ForwardRef as ReactComponent };